import React, { Component } from 'react';
import { Pane, Table, Button, Spinner, Badge } from 'evergreen-ui';
import { connect } from 'react-redux';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import { getOrders } from '../../orders/actions/OrderActions';
import moment from 'moment';

class UserOrdersList extends Component {
    fetchUserOrders() {
        if (this.props.userId) {
            this.props.dispatch(getOrders({
                start: 0,
                limit: 20,
                sort: 'id',
                direction: 'desc',
                extraFilters: {
                    userId: this.props.userId
                }
            }));
        }
    }

    componentDidMount() {
        this.fetchUserOrders();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId) {
            this.fetchUserOrders();
        }
    }

    openOrderInNewTab = (orderId) => {
        window.open(`/orders/${orderId}`, '_blank', 'noopener,noreferrer');
    }

    getStatusBadge = (status) => {
        const statusColors = {
            'placed': 'red',
            'confirmed': 'orange',
            'processed': 'yellow',
            'delivered': 'teal',
            'completed': 'green',
            'cancelled': 'neutral',
            'returning': 'teal',
            'returned': 'purple'
        };
        return statusColors[status] || 'neutral';
    }

    render() {
        const { orders, loading } = this.props;

        return (
            <InfoBlock 
                flex="50%" 
                label="Comenzi Utilizator"
                marginTop={0}>
                {loading ? (
                    <Pane display="flex" justifyContent="center" padding={16}>
                        <Spinner />
                    </Pane>
                ) : (
                    <>
                        {orders && orders.length > 0 ? (
                            <Table>
                                <Table.Head>
                                    <Table.TextHeaderCell>Nr. Comanda</Table.TextHeaderCell>
                                    <Table.TextHeaderCell>Data</Table.TextHeaderCell>
                                    <Table.TextHeaderCell>Valoare</Table.TextHeaderCell>
                                    <Table.TextHeaderCell>Status</Table.TextHeaderCell>
                                    <Table.TextHeaderCell>Tip</Table.TextHeaderCell>
                                    <Table.TextHeaderCell>Actiuni</Table.TextHeaderCell>
                                </Table.Head>
                                <Table.Body>
                                    {orders.map(order => {
                                        const isGuestOrder = !order.userId;
                                        return (
                                            <Table.Row key={order.id}>
                                                <Table.TextCell>{order.orderNumber}</Table.TextCell>
                                                <Table.TextCell>
                                                    {moment(order.createdAt).format('DD.MM.YYYY HH:mm')}
                                                </Table.TextCell>
                                                <Table.TextCell>
                                                    {order.grandTotal > 0 ? `${order.grandTotal} RON` : '-'}
                                                </Table.TextCell>
                                                <Table.TextCell>
                                                    <Badge color={this.getStatusBadge(order.status)}>
                                                        {order.statusText}
                                                    </Badge>
                                                </Table.TextCell>
                                                <Table.TextCell>
                                                    <Badge color={isGuestOrder ? "blue" : "green"}>
                                                        {isGuestOrder ? "Guest" : "Cont"}
                                                    </Badge>
                                                </Table.TextCell>
                                                <Table.TextCell>
                                                    <Button 
                                                        size="small"
                                                        iconBefore="eye-open"
                                                        onClick={() => this.openOrderInNewTab(order.id)}>
                                                        Vezi Comanda
                                                    </Button>
                                                </Table.TextCell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>
                        ) : (
                            <Pane padding={16}>
                                Nu exista comenzi pentru acest utilizator.
                            </Pane>
                        )}
                    </>
                )}
            </InfoBlock>
        );
    }
}

function mapStateToProps(state) {
    return {
        orders: state.orders.data,
        loading: state.loading['ORDERS_GET_ALL_REQUEST'] || false
    };
}

export default connect(mapStateToProps)(UserOrdersList);
